import { Field } from 'formik';
import { Box, Grid, FormControl, Button, useStyleConfig } from '@chakra-ui/react';
import RadioCard from './RadioCard';
import ElementHeading from '../../formElements/components/ElementHeading';
import ElementInstructions from '../../formElements/components/ElementInstructions';
import { exitToMenu } from '../utils';

const ResumeTemplateChooser = (qObj, fieldName, props, index, styles) => {
  const stateProps = props.stateProps;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  return (
    <Box>
      <Field name={fieldName}>
        {({ field, form }) => {
          return (
            <FormControl isInvalid={form.errors[qObj.id] && form.touched[qObj.id]} >
              <Box>

                <ElementHeading qObj={qObj} props={props} />
                <ElementInstructions instructions={qObj.instructions} />
                <Grid
                  templateColumns={[
                    'repeat(1, 1fr)',
                    null,
                    'repeat(2, 1fr)',
                    'repeat(3, 1fr)',
                  ]}
                  gap={8}
                  sx={{ ...styles.templateWrapper }}
                >
                  {qObj.options.map(template => {
                      const inputProps = stateProps.getInputProps();
                      inputProps.value = template.value;
                      inputProps.name = fieldName;
                      return (<RadioCard props={props} qObj={qObj} template={template} inputProps={inputProps} index={index} styles={styles} />);
                    },
                  )}
                </Grid>
              </Box>
            </FormControl>
          );
        }}
      </Field>
      <Button
        sx={{...buttonStyles.primary,...buttonStyles.singleSectionMenu}}
        onClick={() => exitToMenu(props)}
      >
        &lt;&lt; Menu
      </Button>
    </Box>
  );
};

export default ResumeTemplateChooser;
